import Head from 'next/head';
import React, { Component } from 'react';

const LIVERAMP_ID = '13349';
const SCRIPT_SRC = 'https://ats.rlcdn.com/ats.js';
let _isScriptInHead = false;

class LiveRamp extends Component {
  componentDidMount() {
    // Only append script once
    if (_isScriptInHead === false) {
      // Note, the script must be appended to the document instead of using
      // <Head> since we need to respond to the load event.
      const script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      script.onload = function load() {
        window.ats.start({
          placementID: `${LIVERAMP_ID}`,
          storageType: 'localStorage',
          detectionType: 'scrapeAndUrl',
          urlParameter: 'user_email',
          detectionSubject: 'all',
          detectDynamicNodes: true,
          cssSelectors: ['input[type=text]', 'input[type=email]'],
          logging: 'error'
        });
      };
      document.head.appendChild(script);
      _isScriptInHead = true;
    }
  }
  render() {
    return (
      <Head>
        <script key="liveramp-1" />
      </Head>
    );
  }
}

export default LiveRamp;
